module.exports = __webpack_public_path__ + "assets/media/favicon152.f726b31eb43c309e1b79efeedf331393.png";